import { memo } from 'react';
import { BaseButton } from '../BaseButton/BaseButton';
import { ButtonProps } from './Button.types';
import css from './Button.module.scss';
import classNames from 'classnames';

/** This controls builds a basic Button with more options. */

/**
 * A customizable Button component that extends BaseButton with additional styling options.
 *
 * @param id - {@link ButtonProps.id id} description.
 * @param title - {@link ButtonProps.title title} description.
 * @param ariaLabel - {@link ButtonProps.ariaLabel ariaLabel} description.
 * @param styleType - {@link ButtonProps.styleType styleType} description. (default: `'primary'`)
 * @param disabled - {@link ButtonProps.disabled disabled} description. (default: `false`)
 * @param onClick - {@link ButtonProps.onClick onClick} description.
 * @param landingPageStyle - {@link ButtonProps.landingPageStyle boolean} description (default: `false`).
 * @param children - {@link ButtonProps.children children} description.
 */
const Button = memo(({
    id,
    title,
    ariaLabel,
    styleType = 'primary',
    disabled = false,
    onClick,
    landingPageStyle,
    children,
}: ButtonProps) => (
    <BaseButton
        id={id}
        title={title}
        ariaLabel={ariaLabel}
        className={classNames(css.buttonBaseRoot, css[styleType], landingPageStyle && css.landingPageStyle)}
        variant={styleType === 'primary' ? 'contained' : 'outlined'}
        onClick={!disabled && onClick ? onClick : undefined}
        disabled={disabled}
    >
        {children}
    </BaseButton>
));

export default Button;
